import React from 'react';
import { useParams } from 'react-router';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getRealEstatePpr } from './api';

export const path = '/ppr/area/list/:areaId/:id';
export const getPath = (areaId: string, id: string) => `/ppr/area/list/${areaId}/${id}`;

const PageRealEstatePpr: React.FC = (props) => {
  const { id } = useParams<{ id: string }>();

  const RealEstatePpr = Loadable.Map({
    loader: {
      page: () => import('./page'),
      realEstate: () => getRealEstatePpr(id),
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loaded} {...loadedProps} />;
    },
  });

  return <RealEstatePpr {...props} />;
};

export default PageRealEstatePpr;
